import { useState, useEffect } from "react";
import MainLayout from "../components/MainLayout";
import GridPage from "../components/GridPage";
import { bookedHeader } from "../components/HeaderAttribute";
import MainPopup from "../popup-containers/MainPopup";
import PopUpScreenTitle from "../components/PopUpScreenTitle";
import PopUpButtons from "../components/PopUpButtons";
import Loader from "../ReusableComponents/Loader";
import BookingCancelPopup from "../popup-containers/BookingCancelPopup";
import Checkinpopup from "../popup-containers/CheckInPopup";
import CheckOutPopup from "../popup-containers/CheckOutPopup";

const Booked = () => {
  const [bookedData, setBookedData] = useState([
    {
    Id: 1,
    Name: "John",
    GuestMobile: "9638520147",
    FromDate: "2025-06-05",
    ToDate: "2025-06-07",
    LocationName_en: "Chennai",
    Villaname: "Villa Sunset Paradise",
    Status: "Confirmed"
  },
  {
    Id: 2,
    Name: "Livi",
    GuestMobile: "9873216540",
    FromDate: "2025-06-04",
    ToDate: "2025-06-06",
    LocationName_en: "Madurai",
    Villaname: "Villa Green Haven",
    Status: "Pending"
  },
  {
    Id: 3,
    Name: "Livin",
    GuestMobile: "9876543210",
    FromDate: "2025-06-03",
    ToDate: "2025-06-05",
    LocationName_en: "Thanjavur",
    Villaname: "Villa Blue Orchid",
    Status: "On Hold"
  }
  ]);
  const [isLoading, setIsLoading] = useState(false);
  const [submitBtnDisabled, setSubmitBtnDisabled] = useState(false);
  const [rowIndex, setRowIndex] = useState(null);
  const [popUpBookOpen, setpopUpBookOpen] = useState(false);
  const [popUpHoldOpen, setpopUpHoldOpen] = useState(false);
  const [popUpLostOpen, setpopUpLostOpen] = useState(false);


  const CheckInPopup = (rowIndex) => {
    setRowIndex(rowIndex);
    setpopUpBookOpen(true);
  };

  const CheckOutPopUp = (rowIndex) => {
    setRowIndex(rowIndex);
    setpopUpHoldOpen(true);

  };

  const bookingCancelPopup = (rowIndex) => {
    setRowIndex(rowIndex);
    setpopUpLostOpen(true);
  };

  return (
    <MainLayout pageName="3">
      {/* <Loader isVisible={isLoading} size="h-20 w-20" color="border-t-black" blur={true} /> */}

      <GridPage
        title="Booked"
        header={bookedHeader}
        records={bookedData}
        blockView={true}
        addView={true}
        onConfirmBooking={CheckInPopup}
        onHoldEnquiry={CheckOutPopUp}
        onLostEnquiry={bookingCancelPopup}
      />

      {/* {popUpOpen && (
        <MainPopup setpopUpOpen={setpopUpOpen}>
          <PopUpScreenTitle title="Booked Details" />
          <div className="p-4">
            {popupRowData &&
              Object.entries(popupRowData).map(([key, value]) => (
                <div key={key} className="mb-2">
                  <strong>{key}:</strong> {String(value)}
                </div>
              ))}
          </div>
          <PopUpButtons
            setpopUpOpen={setpopUpOpen}
            rowIndex={recordId}
            viewDetails={viewDetails}
            deleteDetails={deleteDetails}
            blockDetails={blockDetails}
            unBlockDetails={unBlockDetails}
            submitBtnDisabled={submitBtnDisabled}
          />
        </MainPopup>
      )} */}

      <MainPopup popUpOpen={popUpBookOpen} setpopUpOpen={setpopUpBookOpen}>
        <PopUpScreenTitle title="Check-In" hederDetails={true} setpopUpOpen={setpopUpBookOpen} />
        <Checkinpopup />
        <PopUpButtons rowIndex={rowIndex} disabledBtn={submitBtnDisabled} />
      </MainPopup>

      <MainPopup popUpOpen={popUpLostOpen} setpopUpOpen={setpopUpLostOpen}>
        <PopUpScreenTitle title="Check-Out" hederDetails={true} setpopUpOpen={setpopUpLostOpen} />
        <CheckOutPopup />
        <PopUpButtons rowIndex={rowIndex} disabledBtn={submitBtnDisabled} />
      </MainPopup>

      <MainPopup popUpOpen={popUpHoldOpen} setpopUpOpen={setpopUpHoldOpen}>
        <PopUpScreenTitle title="Cancel Booking" hederDetails={true} setpopUpOpen={setpopUpHoldOpen} />
        <BookingCancelPopup />
        <PopUpButtons rowIndex={rowIndex} disabledBtn={submitBtnDisabled} />
      </MainPopup>
    </MainLayout>
  );
};

export default Booked;
